import { lazy } from "react";
import RouteGuard from "../routerPermission";

const MaterialsPage = lazy(
  () => import("@/widgets/catalog/materials/MaterialsPage"),
);

/**
 * Materials reuse the product permissions — a role that can already manage
 * products can manage materials, so there is no new permission to provision.
 *
 * One flat route, deliberately: a material has no parent and no children, so
 * unlike categories there is nothing to nest under `:id`. Create and edit are
 * modals on the list, not pages.
 */
const MaterialsRoutes = {
  path: "materials",
  element: (
    <RouteGuard resource="product" action="read">
      <MaterialsPage />
    </RouteGuard>
  ),
};

export default MaterialsRoutes;
